type FAQ = {
	key: string;
	question: string;
	answer: string | (string | { text: string; href: string })[];
};
export type Category = {
	key: string;
	name: string;
	faq: FAQ[];
};

export const FAQ_LIST: Category[] = [
	{
		key: "first",
		name: "はじめに",
		faq: [
			{
				key: "service",
				question: "チャリコはどのようなサービスですか。",
				answer:
					"チャリコとは、専用駐輪場付きの子供乗せ電動自転車の月額定額レンタルサービスです。",
			},
			{
				key: "available-child-number",
				question: "子供乗せシートは何歳の子供が利用できますか。",
				answer:
					"1 歳から（メーカー推奨）、フロントシートは4歳未満まで（メーカー推奨）、リアシートは6歳未満まで（道路交通法）のお子様が利用できます。",
			},
			{
				key: "is-require-regist",
				question: "利用するためには会員登録が必要ですか。",
				answer:
					"会員登録が必要となります。会員登録はWEBサイトの申込画面にて利用可能なメールアドレスをご入力頂き、返信メールに記載されたURLよりお手続き頂きます。",
			},
		],
	},
	{
		key: "register",
		name: "会員登録",
		faq: [
			{
				key: "register-requirement",
				question: "会員登録の際に必要なものは何ですか。",
				answer:
					"緊急連絡時に必要な電話番号及びメールアドレス、決済に利用できるクレジットカードが必要です。",
			},
			{
				key: "email-error-case",
				question:
					"入力したメールアドレスにメールが届かない場合はどうすれば良いですか。",
				answer:
					"迷惑メール設定等によりメールが届かない場合がありますので、設定の確認をお願いします。またご利用のセキュリティソフトやメールソフトにより、迷惑メールフォルダに自動振り分けされたり、削除されている可能性があります。",
			},
			{
				key: "credit-error-case",
				question: "会員登録時にクレジットカードが入力エラーとなります。",
				answer:
					"登録頂けるお支払い方法はクレジットカードのみとなります。 デビットカード、プリペイドカードはご登録頂けません。ご登録されるカードをご確認下さい。",
			},
			{
				key: "forget-password-case",
				question: "パスワードを忘れてしまいました。",
				answer:
					"ログイン画面の「パスワードを忘れてしまった」からパスワードの再発行手続きをお願いします。",
			},
		],
	},
	{
		key: "start",
		name: "利用開始",
		faq: [
			{
				key: "how-to-charge-battery",
				question: "レンタル自転車のバッテリーの充電はどうすれば良いですか。",
				answer:
					"レンタル自転車本体とともにバッテリー充電器も貸出をしますので、ご自宅に持ち帰りご自身で充電をお願いします。バッテリー充電器は受け取るレンタル自転車の前又は後ろの子供乗せシートに袋に入れた状態でセットされていますので、必ずレンタル自転車とともにお持ち帰り下さい。また、レンタル自転車の返却時には、バッテリー充電器も受取時と同じ状態で忘れずに返却をお願いします。",
			},
			{
				key: "start-date-restriction",
				question: "利用開始日の設定に制限はありますか。",
				answer:
					"申込日の5日後から1ヶ月後まで（ともに申込日を算入しない）の間で、利用開始日を設定頂けます。",
			},
			{
				key: "how-to-change-apply",
				question: "利用申込を変更したいです。",
				answer:
					"利用申込の変更はできません。利用申込を一旦キャンセルして頂き、再度ご希望の利用申込をして頂きます。",
			},
			{
				key: "can-cancel-apply",
				question: "利用申込はキャンセルできますか。",
				answer:
					"利用申込のキャンセルは、WEBサイトの申込キャンセル画面から、利用開始日の1週間前までにお願いします。",
			},
			{
				key: "is-delivered-bicycle",
				question: "レンタル自転車の配送はしてくれますか。",
				answer: "申込頂いた専用駐輪場での無人受け渡しのみとなります。",
			},
			{
				key: "how-to-recieve-bicycle",
				question: "利用開始時のレンタル自転車の受取方法を教えて下さい。",
				answer:
					"レンタル自転車は申込頂いた専用駐輪場に用意し、鍵は専用駐輪場のキーBOXからご自身で取り出して頂きます。あらかじめメールにてBOX番号と暗証番号を通知しますので、BOXから鍵2本を受取り、鍵添付のプレートに表示の号機番号と一致するレンタル自転車を解錠して利用開始となります。なお、BOXは利用開始時の鍵受け渡し専用となりますので、利用開始以降、鍵やご自身の私物等を入れないようにお願いします。",
			},
			{
				key: "broken-bicycle-case",
				question:
					"受け取ったレンタル自転車が壊れている場合はどうすれば良いですか。",
				answer:
					"WEBサイトに記載の連絡先あてにメール又は電話で連絡をお願いします。代車確保ができる場合は、代車受取に必要なBOX番号と暗証番号を通知します。代車確保ができない場合は、代車確保できるまでお待ち頂く必要がありますが、その間の利用料金は日割り計算により返金させて頂きます。",
			},
		],
	},
	{
		key: "price",
		name: "利用料金",
		faq: [
			{
				key: "plan",
				question: "契約期間により利用料金が変わりますか。",
				answer: [
					"1ヶ月契約と1年契約とがあり、1年契約の方が割安な料金となります。1ヶ月契約の中途解約の場合、返金はありません。1年契約の中途解約の場合、解約時期に応じて残サービス代金や違約金というご負担が発生します。詳細は",
					{
						text: "WEBサイトの料金表",
						href: "/pdf/price.pdf",
					},
					"をご確認下さい。",
				],
			},
			{
				key: "payment-method",
				question: "利用料金の決済方法は何がありますか。",
				answer: "クレジットカード決済のみとなります。",
			},
			{
				key: "when settled",
				question: "利用料金の決済はいつですか。",
				answer:
					"設定した利用開始日がクレジットカードの決済日となります。例えば、1年契約で4/20が利用開始日の場合、この日が決済日となり、以降5/20、6/20と毎月20日が決済日となります（契約期間は電車等の定期券と同様の考え方）。",
			},
		],
	},
	{
		key: "lending",
		name: "利用中",
		faq: [
			{
				key: "who-use-bicycle",
				question: "レンタル自転車を会員登録した会員以外が運転できますか。",
				answer:
					"レンタル自転車を運転できるのは、会員様の同居親族で成年の方に限られます。",
			},
			{
				key: "how-to-recieve-mainte",
				question: "年2回の定期メンテナンスはどのように受けますか。",
				answer:
					"定期メンテナンスは年2回連続した3日間に専用駐車場で実施します。実施初日の5日前までにメールにて通知しますので、3日間のうち少なくとも1日は専用駐輪場に12時までに駐輪することによりメンテナンスを受けて下さい。なお、当日の実施台数の多少により、駐輪当日にメンテナンス実施ができない場合がありますので、レンタル自転車にメンテナンス済みステッカーが貼り付けてあるかを確認のうえ、貼り付けがない場合は翌日以降も駐輪をお願いします。",
			},
			{
				key: "when-break-bicycle",
				question: "レンタル自転車が故障しました。",
				answer:
					"故障がパンク等のタイヤ本体、タイヤチューブ、バルブ等の消耗品の交換・修理・空気充填で完了する故障の場合は、最寄りの自転車店にご自身で持ち込み修理して下さい。その場合の修理費用は会員様の負担となります。故障がメーカーによる修理を要する自走不能な故障の場合は、WEBサイトに記載の連絡先あてにメール又は電話で連絡をお願いします。故障自転車は回収のうえ修理します。代車確保ができる場合は、代車受取に必要なBOX番号と暗証番号を通知します。代車確保ができない場合は、代車確保できるまでお待ち頂く必要がありますが、その間の利用料金は日割り計算により返金させて頂きます。なお、故障の原因によりレンタル自転車の回収費用や修理費用が会員様の負担となる場合があります。",
			},
			{
				key: "when-accident-cause",
				question: "レンタル自転車を利用中に事故が発生しました。",
				answer:
					"怪我をされている場合は状況に応じて救急車を呼んで下さい。また直ちに事故の状況等を所轄警察とWEBサイトに記載の連絡先あてに電話して下さい。事故による損害のうち損害保険による補償がある場合がありますが、補償限度額を超える損害、レンタル自転車の回収費用、修理費用については全額が会員様の負担となります。なお、代車確保の流れについては、上記故障の場合と同様となりますが、事故の場合は利用料金の日割り計算による返金は行いません。",
			},
			{
				key: "when-bicycle-stolen",
				question: "レンタル自転車が盗難されました。",
				answer:
					"直ちに盗難の状況等を所轄警察とWEBサイトに記載の連絡先あてに電話して下さい。盗難の場合、車体賠償負担金が会員様の負担となりますが、レンタル自転車が発見された場合は、ご負担頂いた車体賠償負担金から回収費用と修理費用を差引いた金額を返金させて頂きます。なお、代車確保の流れについては、上記故障の場合と同様となりますが、盗難の原因が会員様にある場合は利用料金の日割り計算による返金は行いません。",
			},
			{
				key: "when-bicycle-removed",
				question: "レンタル自転車が放置撤去されました。",
				answer:
					"直ちに放置撤去の状況等をWEBサイトに記載の連絡先あてに電話して下さい。放置撤去の場合、会員様が保管場所からレンタル自転車を回収するとともに、放置自転車撤去保管等の諸費用や必要な場合のレンタル自転車の修理費用は会員様にご負担頂きます。また、放置撤去の場合、代車の提供は行いません。",
			},
			{
				key: "when-lose-key",
				question: "レンタル自転車の鍵を紛失しました。",
				answer:
					"直ちに鍵紛失の状況等をWEBサイトに記載の連絡先あてに電話して下さい。レンタル中の鍵２本のうち1本を紛失の場合、スペア鍵受取に必要なBOX番号と暗証番号を通知しますが、これには14日間ほどかかります。2本とも紛失の場合、上記故障で自走不能な場合と同様にレンタル自転車は回収します。また、スペア鍵製作費用、配送費、レンタル自転車の回収費用等は会員様にご負担頂きます。なお、代車確保の流れについては、上記故障の場合と同様となりますが、鍵紛失の場合は利用料金の日割り計算による返金は行いません。",
			},
			{
				key: "how-to-return",
				question: "利用終了時のレンタル自転車の返却方法を教えて下さい。",
				answer:
					"レンタル自転車は申込頂いた専用駐輪場に駐輪して返却して下さい。あらかじめメールにてBOX番号と暗証番号を通知しますので、キーBOXに鍵2本を返却し扉をロックして下さい。なお、BOXは返却時の鍵返却専用となりますので、ご自身の私物等を入れないようにお願いします。",
			},
		],
	},
	{
		key: "others",
		name: "その他",
		faq: [
			{
				key: "bicycle-spen",
				question: "レンタル自転車はどのような自転車ですか。",
				answer:
					"ヤマハの子供乗せ電動自転車（20インチ低床タイプ）になります。新車の提供は保証できません。前カゴ後ろ子供乗せと前後子供乗せの2種類から選択可能です。",
			},
			{
				key: "can-change-color",
				question: "車体の色は指定できますか。",
				answer: "色の指定はできません。",
			},
		],
	},
];
